<template>
  <div>
    <div class="row">
      <div :class="'col-' + treeWidthCol + ' overflow-hidden'" style="border-right: 1px solid #ddd;">
        <div class="widget widget-categories">
          <div class="position-relative w-100 mb-2">
            <input id="search_query" v-model="searchQuery" data-test="search_query" class="form-control" type="text" placeholder="Search collection"
            @input="searchCollection(searchQuery)">
            <i class="fas fa-search fs-lg text-nav position-absolute top-50 end-0 translate-middle-y me-3"></i>
          </div>
          <TreeItem :model="organizedData" :has_children="false" :parent="null" :bus="bus" class="item"></TreeItem>
        </div>
      </div>
      <div class="col">
        <MediaShow
          v-if="selectedMedia && !hideSelectedMedia"
          :collection="collection"
          :hide_media_detail="true"
          :media_slug="selectedMedia.slug"
          >
        </MediaShow>
        <BasicView
          v-else
          :useEvent="true"
          :media="filteredMedia"
          @collection-media-selected="mediaSelectedEvent"
          @collection-folder-selected="folderSelectedEvent"
        />
      </div>
    </div>
  </div>
</template>
<script>
import BasicView from './BasicView.vue';
import MediaShow from '@/views/networks/media/Show.vue';
import TreeItem from './TreeItem.vue';
import Vue from 'vue';

export default {
  components: {
    BasicView,
    MediaShow,
    TreeItem,
  },
  props: {
    collection: {
      type: Object,
      default: null,
    },
    network: {
      type: Object,
      default: null,
    },
  },
  data() {
    let tree = [
      {
        text: this.collection.title,
        slug: this.collection.slug,
        type: 'root',
        dragDisabled: true,
        children: JSON.parse(this.collection.organized_data),
      },
    ];
    let allFilesQuery = '.tree-anchor .fa-file + span';
    let allVideosQuery = '.tree-anchor .fa-tv + span';
    let allFoldersQuery = '.tree-anchor :not(.fa-tv, .fa-file)  + span';
    return {
      bus: new Vue(),
      treeWidthCol: 3,
      hideSelectedMedia: false,
      selectedNode: null,
      selectedMedia: null,
      organizedData: tree,
      filteredMedia: [],
      queries: {
        root: '.tree > .tree-children > .tree-node > .tree-anchor',
        allFiles: allFilesQuery,
        allVideos: allVideosQuery,
        allFolders: allFoldersQuery,
        allMedia: allFilesQuery + ', ' + allVideosQuery,
        allNodes: allFilesQuery + ', ' + allVideosQuery + ', ' + allFoldersQuery,
      },
      searchQuery : '',
    };
  },
  computed: {
    selectedNodeIsMedia() {
      return this.selectedNode;
    },
  },
  created() {
    this.bus.$on('node-selected', node => {
      this.nodeSelected(node);
    });
  },
  mounted() {
    let folderElements = document.querySelectorAll(`ul a[class="folder-class"]`);
    if (folderElements.length != 0) {
      // collapse all folders by default
      folderElements.forEach(element => {
        element.click();
        this.bus.$emit('root-node-selected');
        return;
      });
    } else {
      // no folders, just display root content
      this.bus.$emit('root-node-selected');
    }
  },
  methods: {
    updateMediaSlugInUrl(slug) {
      history.pushState({}, null, this.$route.path + '?slug=' + slug);
    },
    checkIfNodeIsMedia(node) {
      return node.type && (node.type == 'video' || node.type == 'file');
    },
    showSignIn() {
      this.$bus.emit('show-sign-in', this.$route.fullPath, this.$t('auth.signInMessage.protectedMedia'));
    },
    handleAuthorizedMediaForNonLoggedInUser(media) {
      // if user is not registered and clicked media auth
      if (!this.$auth.auth && media.permission == 'authorized') {
        this.showSignIn();
        this.hideSelectedMedia = true;
      } else {
        this.hideSelectedMedia = false;
      }
    },
    nodeSelected(node) {
      //console.log('selected node:', node);
      if (node.type == 'root') {
        this.$bus.emit('show-collection-footer');
      }
      this.selectedNode = node;
      this.searchQuery = '';
      this.filteredMedia.splice(0);
      // populate filteredMedia
      if (this.checkIfNodeIsMedia(node)) {
        this.$bus.emit('hide-collection-footer');
        this.hideSelectedMedia = false;
        this.selectedMedia = this.getMediaFromNode(node);
        this.handleAuthorizedMediaForNonLoggedInUser(this.selectedMedia);
        //this.updateMediaSlugInUrl(node.slug);
        //window.scrollTo(0, 200);
      } else {
        this.getChildrenOfNode(node).forEach(n => {
          if (n.type == 'folder') {
            this.hideSelectedMedia = true;
            return this.filteredMedia.push(this.getFolderFromNode(n));
          } else {
            this.hideSelectedMedia = true;
            return this.filteredMedia.push(this.getMediaFromNode(n));
          }
        });
      }
    },
    getMediaFromNode(node) {
      return this.collection.media.find(m => m.slug == node.slug);
    },
    getFolderFromNode(node) {
      return {
        title: node.text,
        type: 'folder',
        slug: node.slug,
      };
    },
    getChildrenOfNode(node) {
      let children = node.children;
      if (children && children.length > 0) {
        return children;
      }
      return [];
    },
    folderSelectedEvent(folder) {
      let folderElement = document.querySelector(`ul a[href="#${folder.slug}"]`);
      if (folderElement) {
        folderElement.click();
      }
    },
    mediaSelectedEvent(media) {
      //this.updateMediaSlugInUrl(media.slug);
      this.selectedMedia = media;
      this.hideSelectedMedia = false;
      let mediaElement = null;

      this.organizedData[0].children.some(child => {
        if (child.text == media.title) {
          mediaElement = child;
          return true;
        }
        let nestedMatch = child.children.find(m => m.text == media.title);
        if (nestedMatch) {
          mediaElement = nestedMatch;
          return true;
        }
        return false;
      });
      if (mediaElement) {
        this.bus.$emit('selected-node', mediaElement);
      }
    },
    searchCollection(newSearchQuery) {
      if (newSearchQuery.length > 0) {
        let uniqueMediaIds = new Set();
        let media = this.collection.media.filter(m => {
          if (!uniqueMediaIds.has(m.id)) {
            uniqueMediaIds.add(m.id);
            return true;
          }
          return false;
        }).filter(m => m.title.toLowerCase().includes(newSearchQuery.toLowerCase()));
        if (media) {
          if (media.length == 1) {
            this.mediaSelectedEvent(media);
          } else {
            this.filteredMedia.splice(0);
            this.filteredMedia = media;
          }
        }
      } else {
        this.filteredMedia.splice(0);
        this.bus.$emit('root-node-selected');
      }
    },
  },
};
</script>
<style>
.item {
  cursor: pointer;
  line-height: 1.5;
}
.bold {
  font-weight: bold;
}
</style>
